import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold focus:outline-none",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-accent text-accent-foreground",
        secondary:
          "border-transparent bg-surface-3 text-text-secondary",
        destructive:
          "border-transparent bg-surface-4 text-text-secondary",
        outline: "border-glass-border text-text-primary",
        glass:
          "bg-glass-bg border-glass-border text-text-primary",
        success:
          "border-transparent bg-success-muted text-success",
        warning:
          "border-transparent bg-warning-muted text-warning",
        info: "border-transparent bg-surface-3 text-text-secondary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
});
Badge.displayName = "Badge";

export { Badge, badgeVariants };
